import { folderApi } from '@_entities/content';

import { DeleteStrokeIcon, FileEditIcon } from '@_shared/icons';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';

import * as Modal from '@_shared/ui/Modal';
import { Typography } from '@_shared/ui/Typography';

import { folderToast } from '../../libs';

import * as S from './FolderOptionsModal.style';

interface IProps {
	openFolderNameUpdatePopup: () => void;
	openFolderDeletePopup: () => void;
}

export function FolderOptionsModal({ openFolderNameUpdatePopup, openFolderDeletePopup }: IProps) {
	const { popLayer } = useUILayerStore();

	function onOpenFolderDeletePopup() {
		folderApi.checkFolderListLimit().then(({ data: { canDelete } }) => {
			if (!canDelete) {
				folderToast().minFolderCount();
			} else {
				openFolderDeletePopup();
			}
		});
	}

	return (
		<Modal.Container closeModal={popLayer} isButton={false}>
			<S.List>
				<S.Option onClick={openFolderNameUpdatePopup} color="font-secondary">
					<FileEditIcon />
					<Typography type="title-large" color="font-secondary">
						폴더 이름 변경
					</Typography>
				</S.Option>
				<S.Option onClick={onOpenFolderDeletePopup} color="red-primary">
					<DeleteStrokeIcon />
					<Typography type="title-large" color="red-primary">
						폴더 삭제
					</Typography>
				</S.Option>
			</S.List>
		</Modal.Container>
	);
}
